module.exports = __webpack_public_path__ + "img/activague.266357c8.webp";